import React, { useState, useRef, useEffect } from "react";
import "./css/custom-input.css";

const CustomInput = ({
  label,
  type = "text",
  required,
  value,
  setValue,
  placeholder,
  isError,
  errorMessage,
  min
}) => {
  const [isActive, setIsActive] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  const handleFocus = () => {
    setIsFocused(true);
    setIsActive(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
    if (!value) setIsActive(false);
  };

  useEffect(() => {
    if (value) setIsActive(true);
  }, [value]);

  return (
    <div className={`custom-input-wrapper ${isError ? "error-border" : ""}`}>
      <div
        className={`custom-input-container ${
          isFocused ? "change-border-color-select" : ""
        }`}
      >
        {label && (
          <label
            className={`custom-input-label ${isActive ? "active" : ""} ${
              isError ? "error-label" : ""
            }`}
          >
            {label} {required && <span className="required">*</span>}
          </label>
        )}
        <input
          ref={inputRef}
          type={type}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onFocus={handleFocus}
          onBlur={handleBlur}
          min={min}
          placeholder={!isFocused && placeholder ? `${placeholder}` : ""}
          className="custom-input-field"
        />
      </div>
      {isError && <p className="custom-input-error-message">{errorMessage}</p>}
    </div>
  );
};

export default CustomInput;
